import React from 'react';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { useAuthStore } from 'src/context/AuthContext';
import { BunkerReceived } from 'src/types/ViewModel/Bunkering/BunkerReceived';
import { BunkerRegistrationTankStyle } from '../Bunkering.styles';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { getMaxWeight } from '../BunkeringUtils';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { FuelTankType } from 'src/types/ViewModel/Vessel/FuelTankType';
import { TankTypeEnum } from 'src/types/ViewModel/AolEnums';
import { FuelType, getFuelTypeId } from 'src/types/ViewModel/Bunkering/FuelType';
//import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';

interface BunkerRegistrationTankProps {
    tank: Tank;
    literWeight: number | null;
    bunkerReceived: BunkerReceived;
    addTank: (tank: Tank, fuelReceived: number) => void;
    removeTank: (tank: Tank) => void;
    changeFuelReceived: (tank: Tank, fuelReceived: number) => void;
    readOnly: boolean;
    selectedBunkering: Bunkering;
}

const BunkerRegistrationTank: React.FC<BunkerRegistrationTankProps> = ({
    tank,
    literWeight,
    bunkerReceived,
    addTank,
    removeTank,
    changeFuelReceived,
    readOnly,
    selectedBunkering,
}) => {
    const { role } = useAuthStore();

    const handleToggleTank = (toggleTank) => {
        if (toggleTank) {
            addTank(tank, 0);
        } else {
            removeTank(tank);
        }
    };

    const handleFuelReceivedChange = (changeObject: InputChangeData) => {
        const value = parseFloat(changeObject.event.target.value);
        changeFuelReceived(tank, value);
    };

    const checkFuelTypeTankMatch = (fuelType: FuelType): boolean => {
        if (fuelType === FuelType.HFO || fuelType === FuelType.LSF) {
            return tank.tankType === TankTypeEnum.HeavyFuelOil || tank.tankType === TankTypeEnum.LightFuelOil;
        } else if (fuelType === FuelType.LGO) {
            return tank.tankType === TankTypeEnum.MarineGasOil;
        }

        return true;
    };

    const getWarningText = () => {
        if (!bunkerReceived) return '';
        if (!bunkerReceived.bunkerReceivedMt) return 'Enter a value or unselect the tank';
        if (
            selectedBunkering.fuelType === FuelType.BIO
                ? !checkFuelTypeTankMatch(getFuelTypeId(selectedBunkering.bioBlendFossilFuelType))
                : !checkFuelTypeTankMatch(selectedBunkering.fuelType)
        )
            return 'Fuel tank type does not match selected fuel type';
        if (tank.fuelTankType !== FuelTankType.Storage) return `This isn't a storage tank. Sure that the fuel was allocated here?`;
        return '';
    };

    return (
        <BunkerRegistrationTankStyle>
            <OdfjellInputComponent
                type="checkbox"
                name="enableTank"
                value={!!bunkerReceived}
                onChange={() => handleToggleTank(!bunkerReceived)}
                isReadOnly={!role.isWriter || readOnly}
            />
            <OdfjellInputComponent
                type="number"
                name="tankCapacity"
                value={bunkerReceived?.bunkerReceivedMt}
                min={0}
                max={getMaxWeight(tank, literWeight)}
                onChange={handleFuelReceivedChange}
                isReadOnly={!bunkerReceived || !role.isWriter || readOnly}
                unit={bunkerReceived ? 'MT' : ''}
                validationInTooltip
                warningText={getWarningText()}
            />
        </BunkerRegistrationTankStyle>
    );
};

export default BunkerRegistrationTank;
